//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const LocalesFlag: Record<string, string> = {
  'da-dk': '🇩🇰',
  'de-de': '🇩🇪',
  'en-ca': '🇨🇦',
  'en-eu': '🇪🇺',
  'en-gb': '🇬🇧',
  'en-us': '🇺🇸',
  'es-es': '🇪🇸',
  'es-mx': '🇲🇽',
  'es-us': '🇺🇸',
  'et-ee': '🇪🇪',
  'fr-ca': '🇨🇦',
  'fr-fr': '🇫🇷',
  'it-it': '🇮🇹',
  'ja-jp': '🇯🇵',
  'ko-kr': '🇰🇷',
  'lt-lt': '🇱🇹',
  'lv-lv': '🇱🇻',
  'nl-nl': '🇳🇱',
  'pl-pl': '🇵🇱',
  'pt-br': '🇧🇷',
  'ru-ru': '🇷🇺',
  'sv-se': '🇸🇪',
};
